module.exports = __webpack_public_path__ + "img/swift.0fb53b52.svg";